/* eslint-disable no-console */
import React from "react";
import PropTypes from "prop-types";

import logo04 from "./img/logos/hilton.png";
import logo15 from "./img/logos/jockeysalud.svg";
import logo16 from "./img/logos/pacifico.png";
import digitalsignage from "./img/visiona/digital_signage.webp";
import logo from "./img/visiona/visiona-logo.png";
import "./styles.scss";

const Logo = ({ src, alt, className }) => (
  <div className="logo-container-peru">
    <img
      src={src}
      alt={alt}
      className={`logo-image ${className || ""}`}
      onError={(e) => {
        e.target.src = "/path/to/fallback-image.png"; // Imagen de respaldo
      }}
    />
  </div>
);

Logo.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
};

const LandingPeru = () => {
  const contactPhone = "+51 912 410 275"; // Unificar número de contacto
  const contactEmail = "hola@visiona.pe";

  return (
    <div className="landing-wrapper">
      <main className="landing-main">
        <section id="transformacion" className="transformacion-section">
          <h2 className="transformacion-section-titulo">Transformación Digital</h2>
          <p className="transformacion-section-subtitulo">
            Innovación que complementa su estrategia publicitaria con soluciones digitales a medida.
          </p>
          <div className="transformacion-content">
            <div className="transformacion-image">
              <img
                className="transformacion-img"
                src={digitalsignage}
                alt="Soluciones de transformación digital para publicidad"
                onError={(e) => {
                  e.target.src = "/path/to/fallback-image.png"; // Imagen de respaldo
                }}
              />
            </div>
          </div>
          <p className="transformacion-section-bajada">
            Conozca nuestro expertise en proyectos de transformación digital.
          </p>
          <p className="transformacion-section-bajada">
            Soluciones que potencian la comunicación de su empresa puertas adentro y hacia sus clientes.
          </p>
          <div className="transformacion-logos">
            <img src={logo04} alt="Transformación Digital - Hilton" />
            <img src={logo15} alt="Transformación Digital - Volvo" />
            <img src={logo16} alt="Transformación Digital - Volvo" />
          </div>
        </section>
      </main>

      <footer className="footer" id="contacto">
        <div className="footer-content">
          <a href="https://visiona.pe" aria-label="Ir al sitio principal de Visiona">
            <Logo src={logo} alt="Logo de Visiona Perú" />
          </a>
          <div className="footer-center">
            <p>{contactPhone}</p>
            <a href={`mailto:${contactEmail}`} aria-label="Enviar correo a Visiona Perú">
              {contactEmail}
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

LandingPeru.propTypes = {};

export default LandingPeru;
